export const FETCH_PROJECTS_REPORT = "FETCH_PROJECTS_REPORT";
export const FETCH_PROJECTS_REPORT_SUCCESS = "FETCH_PROJECTS_REPORT_SUCCESS";
export const FETCH_PROJECTS_REPORT_FAILED = "FETCH_PROJECTS_REPORT_FAILED";

export const DOWNLOAD_PROJECTS_REPORT = "DOWNLOAD_PROJECTS_REPORT";
export const DOWNLOAD_PROJECTS_REPORT_SUCCESS =
  "DOWNLOAD_PROJECTS_REPORT_SUCCESS";
export const DOWNLOAD_PROJECTS_REPORT_FAILED =
  "DOWNLOAD_PROJECTS_REPORT_FAILED";
